
import CreateCapabilityGroups from './CreateCapabilityGroups';
import EditCapabilityGroups from './EditCapabilityGroups';
import ListCapabilityGroups from './ListCapabilityGroups';
import ViewCapabilityGroups from './ViewCapabilityGroups';

export default { CreateCapabilityGroups, EditCapabilityGroups, ListCapabilityGroups, ViewCapabilityGroups };



// WEBPACK FOOTER //
// ./src/components/pages/admin/capabilityGroups/index.js